import $ from "jquery";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import { getRoomAnswerById } from "@bd-stores/game-data";
import {
    addDocument,
    getFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateFinalRoomAnswer,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import { getCurrentPageId } from "@bd-stores/user-progress";
import {
    getFinalTeamAnswers,
    getPlayers,
    getRoomStatus,
} from "@bd-stores/game-progress";
import fb from "@bd-core/firebase";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import CompletionPopup from "@bd-utils/completion-popup";

export class RoomCaptcha extends BD_Component {
    constructor() {
        super();

        this.id = "captcha";
        this.templateID = "captcha-template";

        this.elms = {
            shareBtn: ".js-share-btn",
            confirmation: "#initialSubmit",
            submitBtn: ".js-submit-btn",
            fingerprintText: ".js-fingerptint-text",
            pointerBtn: ".js-pointer",
            closePopupBtn: ".js-close-popup",
            imageBox: ".js-imagebox",
            imageBoxFullscreen: ".js-imagebox-fullscreen",
            openFullscreenBtn: ".js-open-imagebox-fullscreen",
            closeFullscreenBtn: ".js-close-popup-fullscreen",
            imageBoxImg: ".js-imagebox-img",
            snackbar: ".js-saved-document-snackbar",
            closeSnackbar: ".js-close-snackbar",
            captchaImage: ".js-captcha-image-item",
            openCaptchaPuzzle: ".js-open-captcha-puzzle",
            closeCaptchaPuzzle: ".js-close-captcha-puzzle",
        };

        this._events = this.getEvents();

        this.completionPopup = new CompletionPopup();

        this._data = {};
        this._questions = [];
        this._labels = [];
        this.fbEvents = [];
        this.userAnswers = "";
        this.loadingTime = 3000; //in milisecond ; this can be changed by acf on room setting
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.pointerBtn,
                handler: this.onHandlePointer,
            },
            {
                event: "click",
                selector: elms.closePopupBtn,
                handler: this.onCloseImagePopup,
            },
            {
                event: "click",
                selector: elms.openFullscreenBtn,
                handler: this.handleFullscreen,
            },
            {
                event: "click",
                selector: elms.closeFullscreenBtn,
                handler: this.onCloseFullsceenPopup,
            },
            {
                event: "click",
                selector: elms.closeSnackbar,
                handler: this.onCloseSnackbar,
            },
            {
                event: "click",
                selector: elms.shareBtn,
                handler: this.onAddDocument,
            },
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.submit,
            },
            {
                event: "click",
                selector: elms.captchaImage,
                handler: this.onSelectCaptchaImage,
            },
            {
                event: "click",
                selector: elms.openCaptchaPuzzle,
                handler: this.onOpenCaptchaPuzzle,
            },
            {
                event: "click",
                selector: elms.closeCaptchaPuzzle,
                handler: this.closeCaptchaPuzzle,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.renderPlayRoom();
        this.setGameState();

        const roomStatus = getRoomStatus(this.roomId);
        if (roomStatus !== "is-status-completed") this.listenScannedUsers();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const docsHotspot = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "document",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _documents = this._data.documents.map((doc) => {
            const { document_id } = doc;
            const position = docsHotspot.find(
                (doc) => doc["document_id"] === document_id,
            );
            const position_top = position
                ? position["position_top"]
                : defaultValue;
            const position_left = position
                ? position["position_left"]
                : defaultValue;

            return {
                ...doc,
                position_top,
                position_left,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            documents: _documents,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const correctAnswer = getRoomAnswerById(roomID);
        this.setFingerprintTxt();

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (thisRoomStatus == "is-status-completed") {
            const finalAnswer = getFinalTeamAnswers(roomID);
            const text = this._data.fingerprint_text.completed;

            $(this.elms.submitBtn).addClass("is-success");

            $(this.elms.fingerprintText).html(text);

            /* Show completion popup */
            this.completionPopup.show(
                roomID,
                correctAnswer == finalAnswer,
                finalAnswer,
            );
        }
    }

    renderPlayRoom() {
        const startedAt = +new Date();
        const $playroom = $(".playroom").last();
        const $playroomImage = $playroom.find(".playroom-image");
        const $playroomWrapper = $playroom.find(".playroom-wrapper");

        // show error if onLoad not called more than 10s
        const waitLoad = setInterval(() => {
            const now = +new Date();
            const diff = now - startedAt;
            if (diff > 10 * 1000) {
                // showMessage(viewData.strings.playroom_image_error_load);
                clearInterval(waitLoad);
            }
        }, 100);

        const calculate = () => {
            const imageRatio = $playroomImage.height() / $playroomImage.width();
            const containerRatio = $playroom.height() / $playroom.width();

            let finalHeight;
            let finalWidth;

            if (containerRatio > imageRatio) {
                finalHeight = $playroom.height();
                finalWidth = $playroom.height() / imageRatio;
            } else {
                finalWidth = $playroom.width();
                finalHeight = $playroom.width() * imageRatio;
            }

            $playroomWrapper.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroomImage.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroom.addClass("is-calculated");
        };

        const markAsLoaded = () => {
            clearInterval(waitLoad);
        };

        const onLoad = () => {
            calculate();
            markAsLoaded();
        };

        // if image loaded directly from cached file, it wont trigger onload
        // @ts-ignore
        if ($playroomImage[0].complete) onLoad();
        $playroomImage.on("load", onLoad);
    }

    onHandlePointer(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $imagebox = $(elms.imageBox);
        const $title = $(".playroom-imagebox-title");
        const $description = $(".playroom-imagebox-description");
        const $image = $(".playroom-imagebox-image");
        const title = $this.attr("data-title");
        const docId = $this.attr("data-id");
        const description = $this.data("description");
        const image = $this.data("image");
        const isFullscreen = $this.hasClass("is-fullscreen");
        const newImage = new Image();

        // This is to determine whether tutorial can be shown or not
        // because Tutorial should only be open only if $imagebox is open
        // and $image has been loaded successfully
        // `I` stands for `imagebox`
        // let hasIOpened = false;
        // let hasILoaded = false;

        // const onFinishTransition = () => {
        //     // Prevent prematurely show tutorial when the email hasn't open yet
        //     if (!$imagebox.hasClass('is-open')) return false;

        //     hasIOpened = true;
        //     // showTutorial();
        // };

        // const transitionEndEvent = getTransitionEndEvent();
        // $imagebox.on(transitionEndEvent, onFinishTransition);

        newImage.src = image;
        newImage.onload = function () {
            $image.removeClass("is-loading");
            // hasILoaded = true;
            // showTutorial();
        };

        if (isFullscreen) {
            $imagebox.addClass("is-fullscreen");
        } else {
            $imagebox.removeClass("is-fullscreen");
        }

        $title.html(title);
        $description.html(description);
        $image.find("img").remove();
        $image.addClass("is-loading").append(newImage);
        $imagebox.addClass("is-open");

        $(elms.shareBtn).attr("data-id", docId);
        $(elms.shareBtn).attr("data-url", image);
        $(elms.shareBtn).attr("data-title", title);

        if (
            title.toLowerCase() == "ceo's laptop" ||
            title.toLowerCase() == "chairwoman's laptop"
        ) {
            $imagebox.addClass("is-ceo-laptop");
        } else {
            $imagebox.removeClass("is-ceo-laptop");
        }
    }

    onCloseImagePopup() {
        $(this.elms.imageBox).removeClass("is-open");
    }

    handleFullscreen() {
        const elms = this.elms;
        const $selectedImg = $(elms.imageBoxImg).find("img");
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        const $fullscreenWrapper = $imageboxFullscreen.find(
            ".popup-fullscreen-wrapper",
        );
        const $existingImg = $fullscreenWrapper.find("img");

        if ($existingImg.length) {
            $existingImg.removeClass("is-active");
            $existingImg.remove();
        }

        $selectedImg
            .clone(true)
            .addClass("is-active")
            .appendTo($fullscreenWrapper);
        $imageboxFullscreen.addClass("is-open");
    }

    onCloseFullsceenPopup() {
        const elms = this.elms;
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        $imageboxFullscreen.removeClass("is-open");
    }

    onAddDocument(e) {
        const $this = $(e.currentTarget);
        const id = $this.attr("data-id");
        const url = $this.attr("data-url");
        const title = $this.attr("data-title");

        const docObj = {
            [id]: {
                url,
                title,
            },
        };

        addDocument(docObj)
            .then(() => {
                $(".js-saved-document-snackbar").addClass("is-open");
                setTimeout(() => {
                    $(".js-saved-document-snackbar").removeClass("is-open");
                }, 3000);
            })
            .catch(() => console.error("failed"));
    }

    onCloseSnackbar() {
        $(this.elms.snackbar).removeClass("is-open");
    }

    toggleCheckButton($el) {
        const elms = this.elms;
        const $captchaWrapper = $el.parents(".js-captcha-wrapper");
        const $checkBtn = $captchaWrapper.find(elms.checkAnswer);
        const $images = $captchaWrapper.find(elms.captchaImage);
        let hasAnswer = true;

        $.each($images, function (index, item) {
            const isSelected = $(item).hasClass("is-selected");
            if (!isSelected) {
                hasAnswer = false;
                return false;
            }
        });

        return $checkBtn.prop("disabled", !hasAnswer);
    }

    onCheckPuzzle(e, el) {
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $captchaWrapper = $el.parents(".js-captcha-wrapper").first();
        const captchaId = $captchaWrapper.attr("data-id");
        const $selectedImages = $captchaWrapper.find("img.is-selected");

        if ($selectedImages.length <= 0) return;

        const roomID = this.roomId;
        const roomAnswers = getRoomAnswerById(roomID);
        const correctAnswers = roomAnswers?.[captchaId];

        let isCorrect = true;
        let playerAnswers = [];

        $.each($selectedImages, function (index, image) {
            const imageId = $(image).attr("data-id");

            if (!correctAnswers.includes(imageId)) {
                return (isCorrect = false);
            }

            playerAnswers.push(imageId);
        });

        const updatedAnswer = {
            [captchaId]: playerAnswers,
        };

        if (isCorrect) {
            const onSuccessUpdate = () => {
                this.maybeAllPuzzleCompleted();
            };

            const onErrorUpdate = () => {};

            updateFinalRoomAnswer(roomID, updatedAnswer)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);

            $el.removeClass("is-loading");
        } else {
            $captchaWrapper.addClass("is-incorrect");
            $el.removeClass("is-loading");
        }
    }

    maybeAllPuzzleCompleted() {
        const roomID = this.roomId;
        let roomStatus = "is-status-started";

        getFinalRoomAnswers(roomID).then((data) => {
            const roomAnswers = getRoomAnswerById(roomID);
            const fbRoomAnswers = data.val();

            if (
                !fbRoomAnswers ||
                typeof roomAnswers !== "object" ||
                typeof fbRoomAnswers !== "object"
            ) {
                return;
            }

            if (
                Object.keys(roomAnswers).length ==
                Object.keys(fbRoomAnswers).length
            ) {
                maybeUpdateRoomStatus(roomID, roomStatus);
            }
        });
    }

    setFingerprintTxt() {
        const elms = this.elms;
        const $fingerprintTxt = $(elms.fingerprintTxt);
        const { fingerprint_text } = this._data;
        const { started, completed } = fingerprint_text;

        const roomID = this.roomId;
        const roomStatus = getRoomStatus(roomID);

        if (roomStatus === "is-status-started") {
            $fingerprintTxt.html(started);
        } else if (roomStatus === "is-status-completed") {
            $fingerprintTxt.html(completed);
        }
    }

    getFingerprintRoomStatus() {
        const { room_fingerprint } = this._data;
        if (!room_fingerprint) return;

        const roomStatus = getRoomStatus(room_fingerprint);

        return roomStatus;
    }

    checkIsAllPlayerClicked(playerAnswer) {
        const players = getPlayers();
        const totalOnlinePlayer = players.filter((p) => p.isOnline).length;

        if (!playerAnswer) return false;

        const totalPlayerAnswer = Object.keys(playerAnswer).length;

        if (totalPlayerAnswer < totalOnlinePlayer) return false;

        return true;
    }

    /**
     * If current user hasn't answered anything, don't do anything
     * If all user already submit the answer, room completed
     *
     * That is only applied for user that are currently online, offline user
     * would be ignored
     *
     * @param {*} snapshot
     */
    scanUsersListener(snapshot) {
        const playersAnswer = snapshot.val();
        const completed = "is-status-completed";
        const roomID = getCurrentPageId();
        const hasAllPlayersClicked =
            this.checkIsAllPlayerClicked(playersAnswer);
        const hasBeenCompleted = getRoomStatus(roomID) === completed;

        if (hasBeenCompleted) return;

        if (playersAnswer === null) return;

        if (!hasAllPlayersClicked) return;

        maybeUpdateRoomStatus(roomID, completed);
    }

    /**
     * Callback to check whether the room is ready to finish
     */
    maybeReadyToCompleted() {
        if (this.isTheRoomCompleted()) return;

        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/answers`).then(
            this.scanUsersListener.bind(this),
        );
    }

    /**
     * Callback to check whether the room is ready to finish
     */
    maybeReadyToFinish() {
        if (this.isTheRoomCompleted()) return;

        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/answers`).then(
            this.scanUsersListener.bind(this),
        );
    }

    /**
     * Listener
     * @param {boolean} off turn on/off the event listener
     */
    listenScannedUsers(off = false) {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/answers`;
        const scanHandler = (data) => this.scanUsersListener(data);
        const finishHandler = () => this.maybeReadyToFinish();

        if (off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const ansListener = fb.onValue(path, scanHandler);
            const plyListerner = fb.onValue(fb.playersPath, finishHandler);

            this.fbEvents.push(ansListener);
            this.fbEvents.push(plyListerner);
        }
    }

    maybeReadyToFinishTheGame() {
        const gameProgress = getState().gameProgress;
        const isAllRoomCompleted = gameProgress.allRoomCompleted;

        if (isAllRoomCompleted) {
            bdjs.goAsync(
                bdapi.post("game/finish-game", {
                    middle_state: getState().gameProgress.isMiddleState ? 1 : 0,
                }),
            );
        }
    }

    isTheRoomCompleted() {
        return getRoomStatus(this.roomId) == "is-status-completed";
    }

    beforeDestroy() {
        this.listenScannedUsers(true);
    }

    submit(e) {
        const $this = $(e.currentTarget);
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        let roomStatus = "is-status-started";
        const text = this._data.fingerprint_text.waiting;
        let playerAnswers = {};

        if ($this.hasClass("is-waiting") || $this.hasClass("is-success")) {
            return false;
        }

        this.userAnswers = $this.hasClass("is-loading") ? "" : "is-waiting";

        playerAnswers = this.userAnswers;

        $this.addClass("is-waiting");
        $(this.elms.fingerprintText).html(text);

        updateRoomAnswer(roomID, {
            [currentPlayerId]: {
                answers: playerAnswers,
                isCorrect: true,
            },
        });

        maybeUpdateRoomStatus(roomID, roomStatus);

        this.returnToDefaultState();
    }

    returnToDefaultState() {
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const isCompleted = this.isTheRoomCompleted();

        if (isCompleted) {
            $(this.elms.submitBtn).removeClass("is-failed");
            return;
        }

        setTimeout(() => {
            const text = this._data.fingerprint_text.started;
            const isCompleted = this.isTheRoomCompleted();

            $(this.elms.submitBtn)
                .removeClass("is-waiting")
                .addClass("is-failed");
            $(this.elms.fingerprintText).html(text);

            if (!isCompleted) {
                this.removeFailedBanner();
            }

            updateRoomAnswer(roomID, {
                [currentPlayerId]: {},
            });
        }, 3000);
    }

    removeFailedBanner() {
        const { textStarted, opened } = this._data.fingerprint_text;

        $(this.elms.fingerprintText).html(textStarted);

        setTimeout(() => {
            $(this.elms.fingerprintText).html(opened);
            $(this.elms.submitBtn).removeClass("is-failed");
        }, 1000);
    }

    onSelectCaptchaImage(e) {
        const $this = $(e.currentTarget);
        const $captchaWrapper = $this.parents();
        const $images = $captchaWrapper.find(this.elms.captchaImage);

        const isFromIncorrect = $captchaWrapper
            .parent()
            .hasClass("is-incorrect");

        if (isFromIncorrect) {
            $captchaWrapper.removeClass("is-incorrect");
            $images.removeClass("is-selected");
        }

        $this.toggleClass("is-selected");

        // limit the selected image to 3
        // if ($images.filter('.is-selected').length > 3) {
        //     $this.removeClass("is-selected");
        // }

        if ($images.filter(".is-selected").length >= 3) {
            $(".js-submit-puzzle-btn").prop("disabled", false);
        } else {
            $(".js-submit-puzzle-btn").prop("disabled", true);
        }
    }

    onOpenCaptchaPuzzle(e) {
        const $this = $(e.currentTarget);
        const buttonNumber = $this
            .attr("class")
            .match(/captcha-button-(\d+)/)[1];
        const $overlay = $(".js-captcha-overlay");
        // const $container = $(`.js-captcha-${buttonNumber}`);

        $overlay.removeClass("puzzle-1-open puzzle-2-open puzzle-3-open");

        $overlay.addClass(`puzzle-${buttonNumber}-open`);

        // Show the overlay
        $overlay.addClass("is-open");
    }

    closeCaptchaPuzzle() {
        // const $this = $(e.currentTarget);
        const $overlay = $(".js-captcha-overlay");
        $overlay.removeClass("is-open");
    }
}
